import { ICON_TYPES } from '../constants';

export const AreaIcon = (): JSX.Element => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M18.2239 17.3592L14.8181 11.786C15.6371 11.315 16.4081 10.73 17.1071 10.031L16.0466 8.9705C15.4331 9.584 14.7551 10.0947 14.0351 10.505L11.7536 6.77225C12.1181 6.27575 12.3341 5.663 12.3341 5.00075C12.3341 3.60575 11.3771 2.42975 10.0841 2.096V0.5H8.58412V2.09525C7.29112 2.429 6.33412 3.605 6.33412 5C6.33412 5.66225 6.55012 6.27425 6.91462 6.7715L4.63312 10.5042C3.91312 10.094 3.23512 9.58325 2.62162 8.96975L1.56112 10.0302C2.26012 10.7292 3.03112 11.3142 3.85012 11.7852L0.442871 17.3592L1.72312 18.1415L5.20462 12.4452C6.52537 12.9785 7.92937 13.2447 9.33337 13.2447C10.7374 13.2447 12.1414 12.9785 13.4621 12.4452L16.9436 18.1415L18.2239 17.3592ZM9.33337 3.5C10.1606 3.5 10.8334 4.17275 10.8334 5C10.8334 5.82725 10.1606 6.5 9.33337 6.5C8.50612 6.5 7.83337 5.82725 7.83337 5C7.83337 4.17275 8.50612 3.5 9.33337 3.5ZM5.99962 11.144L8.08687 7.7285C8.46637 7.9025 8.88862 8 9.33337 8C9.77812 8 10.2004 7.9025 10.5799 7.7285L12.6671 11.144C10.5221 11.945 8.14387 11.945 5.99962 11.144Z"
          fill="#43494F"
        />
      </g>
    </svg>
  );
};

AreaIcon.iconType = ICON_TYPES.AREA;
